module.exports = __webpack_public_path__ + "img/girl_001_thumb.65e24ece.jpg";